import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function BackSpaceIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 33 33">
      <path
        d="m19.402 17.94 2.533 2.533q.367.366.934.366.566 0 .933-.366.366-.367.367-.934 0-.566-.367-.933l-2.533-2.533 2.533-2.534q.366-.366.367-.933 0-.567-.367-.933t-.933-.367-.934.367l-2.533 2.533-2.533-2.533q-.367-.367-.934-.367t-.933.367-.367.933.367.933l2.533 2.534-2.533 2.533q-.367.367-.367.933 0 .568.367.934.366.366.933.366t.934-.366zm-6.667 8.8q-.633 0-1.2-.284a2.56 2.56 0 0 1-.933-.783l-6-8a2.57 2.57 0 0 1-.534-1.6q0-.9.534-1.6l6-8q.366-.5.933-.784a2.65 2.65 0 0 1 1.2-.283h14.667q1.099 0 1.883.783.784.784.784 1.884v16q0 1.099-.784 1.883a2.57 2.57 0 0 1-1.883.783zm0-2.667h14.667v-16H12.735l-6 8z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
